import { Fields } from "component-library/earnings-setup/fieldNames";
import { loadDefault } from "earnings/pages/SystemEarningsDefaults";

export function normalizeAssociatedAccrualPlan(value) {
  if (value == null || value === "" || Number(value) === 0) {
    return "";
  }
  return String(value);
}

export function formatMinimumBalanceForInput(value) {
  if (value == null || value === "") {
    return "";
  }
  return String(value);
}

export function sanitizeMinimumBalanceInput(raw) {
  const stripped = String(raw == null ? "" : raw).replace(/[^0-9.]/g, "");
  const firstDot = stripped.indexOf(".");
  if (firstDot === -1) {
    return stripped;
  }
  return (
    stripped.slice(0, firstDot + 1) +
    stripped.slice(firstDot + 1).replace(/\./g, "")
  );
}

export function isWellFormedNonNegativeDecimal(value) {
  if (value === null || value === undefined || value === "") {
    return false;
  }
  const s = String(value).trim();
  if (!/^\d+(\.\d+)?$/.test(s)) {
    return false;
  }
  const n = Number(s);
  return Number.isFinite(n) && n >= 0;
}

/**
 * Options Yes/No handler: Block=Yes fills a blank threshold with 0; Block=No
 * resets threshold and plan so hidden leftovers are not PATCHed (AB#226819).
 */
export function unpaidBlockFlagChangeEdits(blockEnabled, currentThreshold) {
  if (blockEnabled) {
    if (currentThreshold == null || currentThreshold === "") {
      return {
        [Fields.minimumAvailableBalanceToBlock]: formatMinimumBalanceForInput(0)
      };
    }
    return {};
  }
  return {
    [Fields.minimumAvailableBalanceToBlock]: formatMinimumBalanceForInput(0),
    [Fields.associatedAccrualPlan]: ""
  };
}

/**
 * When Calculation Method switches to Hourly, restore persisted unpaid-block
 * values from PrevData (Hourly → other → Hourly). Defaults apply only when
 * PrevData never had those fields (prior method was not hourly).
 */
export function unpaidBlockEditsWhenSwitchingToHourly(prevData = {}, data = {}) {
  const restoredBlock = prevData[Fields.blockRequestWhenAccrualBalanceAvailable];
  if (restoredBlock === null || restoredBlock === undefined) {
    return {
      [Fields.blockRequestWhenAccrualBalanceAvailable]: loadDefault(
        Fields.blockRequestWhenAccrualBalanceAvailable,
        data
      ),
      [Fields.minimumAvailableBalanceToBlock]: formatMinimumBalanceForInput(
        loadDefault(Fields.minimumAvailableBalanceToBlock, data)
      ),
      [Fields.associatedAccrualPlan]: normalizeAssociatedAccrualPlan("")
    };
  }
  const restoredThreshold = prevData[Fields.minimumAvailableBalanceToBlock];
  return {
    [Fields.blockRequestWhenAccrualBalanceAvailable]: restoredBlock,
    [Fields.minimumAvailableBalanceToBlock]: formatMinimumBalanceForInput(
      restoredThreshold == null
        ? loadDefault(Fields.minimumAvailableBalanceToBlock, data)
        : restoredThreshold
    ),
    [Fields.associatedAccrualPlan]: normalizeAssociatedAccrualPlan(
      prevData[Fields.associatedAccrualPlan]
    )
  };
}

/**
 * PATCH values for threshold and associated plan. Block other than Yes always
 * persists threshold 0 and plan null (documented default for Block=No).
 */
export function unpaidBlockPatchThresholdAndPlan(blockEnabled, threshold, plan) {
  if (blockEnabled !== true) {
    return { threshold: 0, plan: null };
  }
  return {
    threshold:
      threshold === "" || threshold == null ? 0 : threshold,
    plan: plan === "" || plan == null ? null : plan
  };
}
